import { Box } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { itemHasErrorOrWarning } from '../../utils';
import { Dropdown } from '../Dropdown';
import { DropdownItemsSection } from '../DropdownItemsSection';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon } from '../utils';
export const NISTDropdown = ({ jobStatus, job }) => {
    const { dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: 'Phone Match',
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: true,
                hasErrorOrWarning: {
                    hasError: job.nistCompliance?.ial2.crosscheck.phoneMatch !== true,
                    hasWarning: false
                }
            },
            {
                text: 'Email Match',
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: true,
                hasErrorOrWarning: {
                    hasError: job.nistCompliance?.ial2.crosscheck.emailMatch !== true,
                    hasWarning: false
                }
            },
            {
                text: 'IDV',
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: true,
                hasErrorOrWarning: {
                    hasError: job.result?.success !== true,
                    hasWarning: false
                }
            },
            {
                text: 'DLV',
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: true,
                hasErrorOrWarning: {
                    hasError: job.result?.dlv?.result?.status !== 'Approved',
                    hasWarning: false
                }
            },
            {
                text: 'REAL ID compliant',
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: true,
                hasErrorOrWarning: {
                    hasError: !job.nistCompliance?.ial2.realId,
                    hasWarning: false
                }
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [itemHasErrorOrWarning, addIconsToDropdownItems]);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: job.nistCompliance?.ial2.compliant === false, dropdownHasWarnings: false, parentJobStatus: jobStatus }), title: "IAL2 Compliance" },
        React.createElement(Box, null,
            React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }))));
};
